import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import {IFaq, IFaqs} from '@dazn/lp-web/src/types';
import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events/index';

export function faqsProxy(component: any): IFaqs {
    const faqs = component?.fields?.entries?.map(({fields}: {fields: IFaq}) => {
        return {
            title: fields.title,
            url: fields.url,
            target: fields.target,
            action: (): void => {
                triggerElementClick({
                    section: elementClickEventTypes.BODY,
                    itemId: 'faq_box',
                    resourceString: fields.title || fields?.url || ''
                });
                if (!fields.url) {
                    return;
                }
                window.open(fields.url, fields.target);
            }
        };
    });

    return {
        title: component?.fields?.title,
        faqs,
        componentType: ComponentTypes.FAQS
    };
}
